

const UserID =  () => {
	let UserID =localStorage.getItem("UserID");
    if(!UserID) return 0;
	return UserID;
	
}

const SessionID =  () => {
	let SessionID =localStorage.getItem("SessionID");
    if(!SessionID) return '';
	return SessionID;
	
}

const Accounts =  () => {
	let UserInfo =localStorage.getItem("UserInfo");
    if(!UserInfo) return '';
	let JsonUserInfo=JSON.parse(UserInfo);
	return JsonUserInfo.Accounts;
}

const Info =  () => {
	let UserInfo =localStorage.getItem("UserInfo");
    if(!UserInfo) return null;
	let JsonUserInfo=JSON.parse(UserInfo);
	return JsonUserInfo;
}

const HeadImg = () => {
	let UserInfo =localStorage.getItem("UserInfo");
    if(!UserInfo) return require('../../assets/img/head.png');
	let jsonInfo=JSON.parse(UserInfo);
	return require(`../../assets/img/head/${jsonInfo.HeadID}.png`);// userinfo.HeadID
}


export default {
	UserID,
	Accounts,
	Info,
	SessionID,
	HeadImg
}
